import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selector"]

  connect() {
    this.originalSelectorClassArray = Array.from(this.selectorTarget.classList)
    this.selectorTarget.dispatchEvent(new Event("change"))
  }

  change({ currentTarget }) {
    currentTarget.classList = Array.from(
      !currentTarget.selectedOptions[0].value ? currentTarget.options[1].classList : currentTarget.selectedOptions[0].classList
    )
      .concat(this.originalSelectorClassArray)
      .join(" ")
  }
}
